<div class="container breathe size">
  <div #map id="map" class="container"></div>
  <router-outlet></router-outlet>
</div>
